import { render, staticRenderFns } from "./Signers.vue?vue&type=template&id=240a6008&scoped=true&"
import script from "./Signers.vue?vue&type=script&lang=ts&"
export * from "./Signers.vue?vue&type=script&lang=ts&"
import style0 from "./Signers.vue?vue&type=style&index=0&id=240a6008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a6008",
  null
  
)

export default component.exports